var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTheme = function SvgTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 7,
    fill: "#FFB82F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.25C5.5 4.76675 5.89175 4.375 6.375 4.375C6.85825 4.375 7.25 4.76675 7.25 5.25V6.125C7.25 6.60825 6.85825 7 6.375 7C5.89175 7 5.5 6.60825 5.5 6.125V5.25Z",
    fill: "#523B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 5.25C10.75 4.76675 11.1418 4.375 11.625 4.375C12.1082 4.375 12.5 4.76675 12.5 5.25V6.125C12.5 6.60825 12.1082 7 11.625 7C11.1418 7 10.75 6.60825 10.75 6.125V5.25Z",
    fill: "#523B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69878 9.23032C6.48835 9.05151 6.1728 9.07714 5.99399 9.28757C5.81518 9.498 5.84081 9.81354 6.05124 9.99236C6.79308 10.6227 7.85002 11 9.00001 11C10.15 11 11.2069 10.6227 11.9488 9.99236C12.1592 9.81354 12.1848 9.498 12.006 9.28757C11.8272 9.07714 11.5117 9.05151 11.3012 9.23032C10.7604 9.68988 9.94074 10 9.00001 10C8.05928 10 7.23959 9.68988 6.69878 9.23032Z",
    fill: "#523B0F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text",
    fill: "var(--on-surface)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4H37V6H21V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8H45V10H21V8Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cards",
    fill: "var(--surface)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38C0 35.7909 1.79086 34 4 34H12C14.2091 34 16 35.7909 16 38V46C16 48.2091 14.2091 50 12 50H4C1.79086 50 0 48.2091 0 46V38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 38C19 35.7909 20.7909 34 23 34H31C33.2091 34 35 35.7909 35 38V46C35 48.2091 33.2091 50 31 50H23C20.7909 50 19 48.2091 19 46V38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 38C38 35.7909 39.7909 34 42 34H50C52.2091 34 54 35.7909 54 38V46C54 48.2091 52.2091 50 50 50H42C39.7909 50 38 48.2091 38 46V38Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active",
    fill: "var(--accent)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22C7 20.8954 7.89543 20 9 20C10.1046 20 11 20.8954 11 22C11 23.1046 10.1046 24 9 24C7.89543 24 7 23.1046 7 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27H18V28H0V27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "inactive",
    fill: "var(--accent)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 22C25 20.8954 25.8954 20 27 20C28.1046 20 29 20.8954 29 22C29 23.1046 28.1046 24 27 24C25.8954 24 25 23.1046 25 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27H36V28H18V27Z",
    fill: "var(--outline)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "inactive",
    fill: "var(--accent)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 20.8954 43.8954 20 45 20C46.1046 20 47 20.8954 47 22C47 23.1046 46.1046 24 45 24C43.8954 24 43 23.1046 43 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 27H54V28H36V27Z",
    fill: "var(--outline)"
  })))));
};
export default SvgTheme;